import { render, staticRenderFns } from "./news.vue?vue&type=template&id=6541813e&lang=pug"
import script from "./news.vue?vue&type=script&lang=coffee"
export * from "./news.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {News: require('/opt/build/repo/site/components/globals/news.vue').default})
